import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("img", _mergeProps({
    src: _ctx.displaySrc,
    key: _ctx.displaySrc
  }, _ctx.$attrs, { alt: _ctx.alt }), null, 16, ["src", "alt"]))
}